import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import CapturaRapida from './pages/capturas/CapturaRapida';
import Usuarios from './pages/usuarios/Usuarios';
import Estructuras from './pages/estructuras/Estructuras';
import Duplicidades from './pages/duplicidades/Duplicidades';
import BancoTalento from './pages/talento/BancoTalento';
import Reportes from './pages/reportes/Reportes';
import Admin from './pages/admin/Admin';
import Inventario from './pages/inventario/Inventario';
import TocaPromueve from './pages/toca/TocaPromueve';
import Mensajeria from './pages/mensajeria/Mensajeria';
import TalentoAvanzado from './pages/talento2/TalentoAvanzado';
import ReportesAvanzados from './pages/reportes2/ReportesAvanzados';
import Movilizacion from './pages/movilizacion/Movilizacion';
import CoberturaCampo from './pages/cobertura/CoberturaCampo';
import Asignaciones from './pages/asignaciones/Asignaciones';
import OrganigramaEstructura from './pages/organigrama/OrganigramaEstructura';
import ConflictosPoliticos from './pages/conflictos/ConflictosPoliticos';
import Auditoria from './pages/auditoria/Auditoria';
import ValidacionMasiva from './pages/validacion/ValidacionMasiva';
import CatalogoProgramas from './pages/catalogos/CatalogoProgramas';
import CasillasModule from './components/RepresentantesCasilla/CasillasModule';
import MisPromovidos from './pages/promovidos/MisPromovidos';

// Roles con acceso permitido a Toca y Promueve
const ROLES_TOCA = [
  'superadmin',
  'coordinador_general',
  'coordinador_territorial',
  'coordinador_sectorial',
  'seccional',
  'operador',
  'promotor',
  'auditor'
];

// Ruta protegida (solo requiere estar logueado)
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" />;
};

// Ruta protegida por rol específico
const RoleRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" />;
  if (!roles.includes(user.rol)) return <Navigate to="/dashboard" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={
            <PrivateRoute><Dashboard /></PrivateRoute>
          } />
          <Route path="/captura" element={
            <PrivateRoute><CapturaRapida /></PrivateRoute>
          } />
          <Route path="/usuarios" element={
            <PrivateRoute><Usuarios /></PrivateRoute>
          } />
          <Route path="/estructuras" element={
            <PrivateRoute><Estructuras /></PrivateRoute>
          } />
          <Route path="/duplicidades" element={
            <PrivateRoute><Duplicidades /></PrivateRoute>
          } />
          <Route path="/talento" element={
            <PrivateRoute><BancoTalento /></PrivateRoute>
          } />
          <Route path="/reportes" element={
            <PrivateRoute><Reportes /></PrivateRoute>
          } />
          <Route path="/inventario" element={
            <PrivateRoute><Inventario /></PrivateRoute>
          } />
          <Route path="/admin" element={
            <PrivateRoute><Admin /></PrivateRoute>
          } />
          <Route path="/toca" element={
            <RoleRoute roles={ROLES_TOCA}><TocaPromueve /></RoleRoute>
          } />
          <Route path="/mensajeria" element={
            <PrivateRoute><Mensajeria /></PrivateRoute>
          } />
          <Route path="/talento-avanzado" element={
            <PrivateRoute><TalentoAvanzado /></PrivateRoute>
          } />
          <Route path="/reportes-avanzados" element={
            <PrivateRoute><ReportesAvanzados /></PrivateRoute>
          } />
          <Route path="/movilizacion" element={
            <PrivateRoute><Movilizacion /></PrivateRoute>
          } />
          <Route path="/asignaciones" element={
            <PrivateRoute><Asignaciones /></PrivateRoute>
          } />
          <Route path="/organigrama" element={
            <PrivateRoute><OrganigramaEstructura /></PrivateRoute>
          } />
          <Route path="/cobertura" element={
            <PrivateRoute><CoberturaCampo /></PrivateRoute>
          } />
          <Route path="/auditoria" element={
            <PrivateRoute><Auditoria /></PrivateRoute>
          } />
          <Route path="/conflictos" element={
            <PrivateRoute><ConflictosPoliticos /></PrivateRoute>
          } />
          <Route path="/validacion" element={
            <PrivateRoute><ValidacionMasiva /></PrivateRoute>
          } />
          <Route path="/catalogo-programas" element={
            <PrivateRoute><CatalogoProgramas /></PrivateRoute>
          } />
          <Route path="/casillas" element={
            <PrivateRoute><CasillasModule /></PrivateRoute>
          } />
          <Route path="/mi-casilla" element={
            <PrivateRoute><CasillasModule /></PrivateRoute>
          } />
          <Route path="/mis-promovidos" element={
            <PrivateRoute><MisPromovidos /></PrivateRoute>
          } />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
